// extracted by mini-css-extract-plugin
export default {"spinnerOverlay":"Spinner_spinnerOverlay__ZDH3x","spinnerContainer":"Spinner_spinnerContainer__-PvaY","spin":"Spinner_spin__Wib-i"};